export default __webpack_public_path__ + "static/favicon-sitenu-376c47ac54b654a4bc47e784069ff046.png";